export default "__VITE_ASSET__7a50ca06__"